import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { RepresentativeService } from 'src/app/Service/Representative/Representative.service';

@Component({
  selector: 'app-RepresentativeList',
  templateUrl: './RepresentativeList.component.html',
  styleUrls: ['./RepresentativeList.component.scss']
})
export class RepresentativeListComponent implements OnInit {

  Token:String=""
  page:number=0;
  Procssing:boolean=false

  constructor(
    private Alertify_Service:AlertifyService,
    private Representative_Service:RepresentativeService,
    private Nav_Service:NavService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,1101).subscribe(
      data=>{
        this.ReadData_Representative()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )
  }

  DataList_Representative:Array<Customer_List_Interface>=[]
  ReadData_Representative(){
    this.Procssing=true

    this.Representative_Service.GetRecord(this.Token ).subscribe(
      data=>{
        this.DataList_Representative=data
        this.Procssing=false
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

  Data_Seleted_Delete:any
  openModal(template: TemplateRef<any>,Record) {
    this.Data_Seleted_Delete=Record
    this.modalRef_Delete = this.modalService.show(template);
  }


  modalRef_Delete: any;
  Delete(item:Customer_List_Interface){
    item.DeletingProccess=true
    this.modalRef_Delete.hide()
    this.Representative_Service.DeleteRepresentative(item.id,this.Token).subscribe(
      data=>{
        if(data['id']==-1)
          this.Alertify_Service.ErrorMessage("No more than three representatives can be active.")
        else if(item['del']==false)
          this.Alertify_Service.SuccessMessage("Deactivated successfully.")
        else
          this.Alertify_Service.SuccessMessage("Activated successfully.")

        this.ReadData_Representative()
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }

}
